import requests from 'api/index';

const prefixURL = '/employee/memberadmin';
const prefixNextURL = '/employee/memberadmin/next';

export default {
  getRegion: payload => requests.post(`${prefixNextURL}/rest/v1/servicedesk/nosession/region?noSessionPrc=Y`, payload),
  getCompany: payload =>
    requests.post(`${prefixNextURL}/rest/v1/servicedesk/nosession/company?noSessionPrc=Y`, payload),
  getAuthenticateFnm: payload =>
    requests.post(`${prefixNextURL}/rest/v1/emp/nosession/authenticate/fnm?noSessionPrc=Y`, payload),
  getAuthenticateCallPhone: payload =>
    requests.post(`${prefixNextURL}/rest/v1/emp/nosession/authenticate/cellphone?noSessionPrc=Y`, payload),
  getAuthenticateExternalMail: payload =>
    requests.post(`${prefixNextURL}/rest/v1/emp/nosession/authenticate/externalmail?noSessionPrc=Y`, payload),
  getAuthenticateAuthNum: payload =>
    // requests.post(`${prefixNextURL}/rest/v1/emp/nosession/authenticate/authnum?noSessionPrc=Y`, payload),
    requests.postHTTPS(`${prefixNextURL}/rest/v1/emp/nosession/authenticate/authnum?noSessionPrc=Y`, payload),
  modifyAuthenticatePassword: payload =>
    requests.postHTTPS(`${prefixNextURL}/rest/v1/emp/nosession/authenticate/updatepwd?noSessionPrc=Y`, payload),
  modifyPasswordWithCurrentPassword: payload =>
    requests.post(`${prefixNextURL}/rest/v1/pwd/nosession/update/user?noSessionPrc=Y`, payload),
  checkCurrentPassword: payload =>
    requests.post(`${prefixNextURL}/rest/v1/pwd/nosession/check?noSessionPrc=Y`, payload),
  getTelCodeList: payload =>
    requests.post(`${prefixNextURL}/rest/v1/pwd/nosession/telcode/list?noSessionPrc=Y&locale=${payload.language}`, {}),
  getAddressNationList: payload =>
    requests.post(
      `${prefixNextURL}/rest/v1/pwd/nosession/addrNation/list?noSessionPrc=Y&locale=${payload.language}`,
      {},
    ),
  addEmp: payload => requests.post(`${prefixNextURL}/rest/v1/id/nosession/newemp?noSessionPrc=Y`, payload),
  getCheckOTP: payload => requests.post(`${prefixNextURL}/rest/v1/id/nosession/checkOTP?noSessionPrc=Y`, payload),
  getDoubleCheck: payload => requests.post(`${prefixNextURL}/rest/v1/id/nosession/doublecheck?noSessionPrc=Y`, payload),
  getValidate: payload => requests.post(`${prefixNextURL}/rest/v1/id/nosession/validate?noSessionPrc=Y`, payload),
  modifyEmp: payload => requests.post(`${prefixNextURL}/rest/v1/emp/nosession/update?noSessionPrc=Y`, payload),
  getCountryList: () => requests.get(`${prefixURL}/rest/v2/nosession/cntry?noSessionPrc=Y`),
  getTermsContentList: payload =>
    requests.get(
      `${prefixURL}/rest/v2/nosession/cntry/terms/cn?noSessionPrc=Y&langCd=${payload.langCd}&cntryCd=${payload.cntryCd}`,
    ),

  /* kms */
  // 패스워드 체크
  getCheckPinCode: payload =>
    // requests.post(`${prefixNextURL}/rest/v1/kms/nosession/reset/check/pin?noSessionPrc=Y`, payload),
    requests.postHTTPS(
      `${prefixNextURL}/rest/v1/kms/nosession/reset/check/pin?noSessionPrc=Y`,
      payload,
      '',
      'application/json',
    ),
  // 모바일 사용자 체크
  getCheckMobileUser: payload =>
    requests.post(`${prefixNextURL}/rest/v1/kms/nosession/reset/check/mobile?noSessionPrc=Y`, payload),
  // 핀 발송 이메일 주소 조회
  getPinSendEmail: payload => requests.post(`${prefixNextURL}/rest/v1/kms/nosession/get/info?noSessionPrc=Y`, payload),
  // 신규 패스워드 입력 후 저장
  modifyPasswordKms: payload => requests.postHTTPS(`${prefixNextURL}/rest/v1/kms/reset/save?noSessionPrc=Y`, payload),
  getMobileToken: payload =>
    requests.post(`${prefixNextURL}/rest/v1/kms/nosession/reset/request/mobile?noSessionPrc=Y`, payload),
  addMobilePush: payload =>
    requests.post(`${prefixNextURL}/rest/v1/kms/nosession/reset/temp/save/mobile?noSessionPrc=Y`, payload),
  addSkip: payload => requests.post(`${prefixNextURL}/rest/v1/kms/nosession/reset/skip?noSessionPrc=Y`, payload),
  getPolicyVersionZone: payload =>
    requests.get(`${prefixURL}/rest/v2/nosession/terms/policy/version/zone?noSessionPrc=Y&zoneCd=${payload.zoneCd}`),
  getTermsCn: payload =>
    requests.get(
      `${prefixURL}/rest/v2/nosession/terms/cn?noSessionPrc=Y&trmsCd=${payload.trmsCd}&trmsVerVal=${payload.trmsVerVal}`,
    ),
};
